import { Text, View, StyleSheet } from '@react-pdf/renderer';
import React from 'react';
import { useTranslation } from 'react-i18next';
import commonStyles from '../commonStyles';
import defaultTextValue from '../defaultTextValue';
const styles = StyleSheet.create({
    footer: Object.assign(Object.assign({ position: 'absolute', left: '4%', bottom: '1.5%', right: '4%' }, commonStyles.fontXS), { fontWeight: 'medium', display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }),
    description: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'flex-start',
    },
    code: {
        marginRight: 10,
    },
    date: {
        marginRight: 10,
    },
});
function convertToReadableDate(date) {
    const localDate = date
        .toLocaleDateString('pl-PL', { timeZone: 'Europe/Warsaw' })
        .split('.')
        .reverse()
        .join('-');
    const time = date.toLocaleTimeString('pl-PL', { timeZone: 'Europe/Warsaw' });
    return localDate.concat(` ${time}`);
}
function Footer({ date, code, author, folder, model }) {
    const { t } = useTranslation(['specification', 'common']);
    const readableDate = convertToReadableDate(date);
    return (React.createElement(View, { style: styles.footer, fixed: true },
        React.createElement(View, { style: styles.description },
            React.createElement(View, null,
                React.createElement(Text, { style: styles.code },
                    t('product_serial_number'),
                    ": ",
                    defaultTextValue(code)),
                React.createElement(Text, { style: styles.date },
                    t('generated_date'),
                    ": ",
                    defaultTextValue(readableDate),
                    " | ",
                    t('common:author'),
                    ":",
                    defaultTextValue(author))),
            React.createElement(Text, null,
                defaultTextValue(folder),
                ' > ',
                defaultTextValue(model))),
        React.createElement(View, null,
            React.createElement(Text, { render: ({ pageNumber, totalPages }) => t('page_from_to', {
                    page: pageNumber,
                    totalPages,
                }) }))));
}
export default Footer;
